var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.clickIcon}},[_c('svg',{staticClass:"icon-font",attrs:{"fill":"currentColor","stroke":"currentColor","aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":'#' + _vm.iconName,"fill":"currentColor","stroke":"currentColor"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }